import { LegacyGeozoneType } from "../../../api/types/Geozone";

export const ZONE_TYPES_OPTIONS = [
  { id: "CIRCLE", label: "Circle", value: `${LegacyGeozoneType.CIRCLE}` },
  { id: "POLYGON", label: "Polygon", value: `${LegacyGeozoneType.POLYGON}` },
  { id: "ROUTE", label: "Route", value: `${LegacyGeozoneType.ROUTE}` },
];

export const ZONE_COLOR_OPTIONS = [
  { id: "DEFAULT", value: "", label: "Default" },
  { id: "BLACK", value: "#000000", label: "Black" },
  { id: "BROWN", value: "#a52a2a", label: "Brown" },
  { id: "RED", value: "#dd0000", label: "Red" },
  { id: "ORANGE", value: "#ffa500", label: "Orange" },
  { id: "ORANGE", value: "#ffd700", label: "Yellow" },
  { id: "GREEN", value: "#00cc00", label: "Green" },
  { id: "BLUE", value: "#0000ee", label: "Blue" },
  { id: "PURPLE", value: "#9400d3", label: "Purple" },
  { id: "GRAY", value: "#505050", label: "Gray" },
  { id: "GRAY", value: "#ffffff", label: "White" },
  { id: "CYAN", value: "#00ffff", label: "Cyan" },
  { id: "PINK", value: "#ff1493", label: "Pink" },
];

export const OVERLAP_PRIORITY_OPTIONS = [
  { id: "ZERO", label: "0", value: "0" },
  { id: "ONE", label: "1", value: "1" },
  { id: "TWO", label: "2", value: "2" },
  { id: "THREE", label: "3", value: "3" },
  { id: "FOUR", label: "4", value: "4" },
  { id: "FIVE", label: "5", value: "5" },
  // { id: "SIX", label: "6", value: "6" },
  // { id: "SEVEN", label: "7", value: "7" },
  // { id: "EIGHT", label: "8", value: "8" },
  // { id: "NINE", label: "9", value: "9" },
  // { id: "TEN", label: "10", value: "10" },
];
